import React from 'react';
import { ShimmerWrapper, ShimmerPill } from './styled';

const ActionBubbleShimmer: React.FC = () => {
  return (
    <ShimmerWrapper>
      <ShimmerPill />
      <ShimmerPill />
      <ShimmerPill />
    </ShimmerWrapper>
  );
};

export default ActionBubbleShimmer;
